import { Content } from '../../types';

export const kampotContent: Content = {
  title: 'קמפוט – הפנינה השלווה של דרום קמבודיה',
  imageUrl: 'https://tinyurl.com/kampot-wide',
  introduction: `קמפוט הינה עיר תיירותית קטנה, שלווה וממכרת בדרום קמבודיה, השוכנת על גדות נהר קמפוט (Kampot River), כ-135 ק"מ מעיר הבירה פנום פן. העיר ידועה באווירה הרגועה שלה, במבניה הקולוניאליים הצרפתיים ובנוף עוצר הנשימה המקיף אותה.`,
  sections: [
    {
      title: 'מבנה העיר וחלוקה גאוגרפית',
      content: `נהר קמפוט חוצה את העיר ומחלק אותה לשני אזורים מרכזיים:
הצד המזרחי של הנהר – בו נמצאים בתי התושבים המקומיים, שירותי התיירות, בתי המלון, מקומות הבילוי, המסעדות, מרכזי הקניות, השווקים ושירותי התחבורה.
הצד המערבי של הנהר – אזור כפרי יותר ובו מספר גסטהאוסים, בתי מלון מעטים ומגורים כפריים המציעים נוף שליו וקרבה לטבע.`,
      type: 'text',
    },
    {
      title: 'אטרקציות ופעילויות בקמפוט',
      content: [
        'שמורת הטבע הלאומית בוקור (Bokor National Park) – פארק מרשים הכולל שרידים של כפר צרפתי עתיק ונטוש, מסלולי הליכה, חיות בר, מפלים ונופים פנורמיים מדהימים.',
        'שדות המלח – חוויה ייחודית בה ניתן לראות כיצד המקומיים מפיקים מלח באופן מסורתי.',
        'חוות הפלפל (La Plantation) – ביקור בחווה בה מגדלים את הפלפל המפורסם של קמפוט, הידוע כאחד האיכותיים בעולם.',
        'Secret Lake – אגם בעל משמעות היסטורית הנמצא בדרך לחוות הפלפל, מושלם לעצירה מרגיעה ואותנטית בדרך.',
        'Rapids Tek Chhou – אזור בו ניתן לשוט בנהר, לרחוץ במים הקרירים וליהנות מהצל של העצים.',
        'Tada Waterfall – מפל מים יפהפה (בעיקר בעונה הגשומה) המספק חוויה טבעית ומרגיעה.',
        'מערת Phnom Sorsia – מערת נטיפים מעניינת בה ניתן למצוא פסלים בודהיסטיים ונקודות תצפית יפות.',
      ],
      type: 'list',
    },
    {
      title: 'דרכי ההתניידות בעיר ובמרחב',
      content: `ניתן לשכור אופניים כדי לטייל בין הכפרים הסמוכים ולאטרקציות הקרובות או קטנועים כדי להגיע לאתרים רחוקים יותר. התחבורה הציבורית מוגבלת, ולכן כלי רכב פרטי הוא אופציה נוחה יותר למי שמעוניין בחופש תנועה מלא.`,
      type: 'text',
    },
    {
      title: 'חוויית השקיעה ושייט בנהר',
      content: `לקראת ערב, מומלץ לצאת לשייט שקיעה בנהר – חוויה קסומה המאפשרת לצפות בלהקות ציפורים החגות מעל המים ובנוף ההררי הנשקף ברקע. ניתן גם לשבת על שפת הנהר וליהנות מהאווירה הרגועה ומהנוף המשתנה עם אור השקיעה.`,
      type: 'text',
    },
    {
      title: 'חיי הלילה והבילוי בקמפוט',
      content: `חיי הלילה של העיר מאופיינים בשלווה המיוחדת של קמפוט. ברחובות הסמוכים לנהר, במיוחד מול סניף סטארבקס המקומי, ניתן למצוא ברים, פאבים, מסעדות ובתי קפה המציעים אווירה נינוחה, מוזיקה חיה ומפגשים עם מטיילים מכל העולם.`,
      type: 'text',
    },
    {
      title: 'דרכי ההגעה לקמפוט',
      content: [
        'מפנום פן – ניתן להגיע בתחבורה ציבורית (אוטובוסים ומיניוואנים) או באמצעות רכבת, המציעה נסיעה נוחה עם נופים יפים לאורך הדרך.',
        'מסיהאנוקוויל – קיים קו תחבורה ציבורית המאפשר הגעה ישירה לעיר.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `קמפוט הינה יעד מושלם לאלו המחפשים שקט, טבע וחוויות מקומיות אותנטיות. העיר משלבת היסטוריה, נוף מדהים, חקלאות ייחודית ואווירה שאין שני לה. בין אם מדובר בטיול קצר או בשהות ארוכה יותר, קמפוט מציעה קסם מיוחד שקשה להישאר אדישים אליו.`,
      type: 'text',
    },
  ],
};
